<template>
  <b-row v-if="loading">
    <b-col
      sm="12"
      class="text-center"
    >
      <b-skeleton
        class="d-inline-block"
        animation="wave"
        width="55%"
        height="500px"
      />
    </b-col>
  </b-row>
  <section v-else>
    <scroll-container
      class="pt-2 mt-n30px"
      height-offset="140px"
    >
      <b-container class="container-small">
        <b-alert
          show
          variant="primary"
          dismissible
          class="p-1"
        >
          <span>{{ $tk('ClientPortal.Account.WithdrawMoneyFromAccount') }}</span>
        </b-alert>
        <b-card
          class="mb-3"
        >
          <b-row>
            <b-col>
              <b-form-group
                class="mb-2"
                :label="$tk('ClientPortal.Withdraw.Amount') + ' *'"
                :invalid-feedback="errorMessages['Amount']"
                :state="errorMessages['Amount'] == null ? null : false"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="withdraw-amount"
                    ref="withdrawValue"
                    v-model.number="withdrawModel.amount"
                    type="number"
                    min="0"
                    :placeholder="$currencyPlaceholder"
                    autocomplete="off"
                    :state="errorMessages['Amount'] == null ? null : false"
                  />
                  <b-input-group-append
                    is-text
                  >
                    {{ $currencySymbol }}
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-checkbox
                id="allProfit"
                :checked="isAllProfitAdded"
                class="mt-3"
                name="allProfit"
                @change="addAllProfit"
              >
                {{ $tk('ClientPortal.Wthdraw.AddAllProfit') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Withdraw.BankAccountNumber') + ' *'"
            :invalid-feedback="errorMessages['BankAccountNumber']"
          >
            <b-form-input
              v-model="withdrawModel.bankAccountNumber"
              name="BankAccountNumber"
              type="text"
              :placeholder="$tk('ClientPortal.Withdraw.BankAccountNumberPlaceholder')"
              :state="errorMessages['BankAccountNumber'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Withdraw.BillNumber') + ' *'"
            :invalid-feedback="errorMessages['BillNumber']"
          >
            <b-form-input
              v-model="withdrawModel.billNumber"
              type="text"
              name="BillNumber"
              :placeholder="$tk('ClientPortal.Withdraw.BillNumberPlaceholder')"
              :state="errorMessages['BillNumber'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Withdraw.Message')"
            :invalid-feedback="errorMessages['Message']"
          >
            <b-form-textarea
              v-model.number="withdrawModel.message"
              :placeholder="$tk('ClientPortal.Withdraw.MessagePlaceholder')"
              :state="errorMessages['Message'] == null ? null : false"
              maxlength="500"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Withdraw.Invoice') + ' *'"
            class="mb-0"
            :invalid-feedback="errorMessages['File']"
            :state="errorMessages['File'] == null ? null : false"
          >
            <vue-dropzone
              id="dropzone"
              ref="videoDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              style="width:100%; text-align: center;border-style: dashed;"
              @vdropzone-file-added="setFile"
            >
              <div class="dropzone-custom-content">
                <b-button
                  variant="outline-primary"
                  class="mr-2"
                  size="sm"
                  style="pointer-events:none"
                >
                  <GjIcon
                    class="mr-50"
                    name="Upload"
                  />
                  {{ $tk('ClientPortal.Withdraw.UploadInvoice') }}
                </b-button>
              </div>
            </vue-dropzone>
            <span
              id="upload-status"
              :class="isError ? 'text-danger' : 'text-success'"
            />
          </b-form-group>
        </b-card>
      </b-container>
    </scroll-container>
    <div class="border-top text-right py-1">
      <div class="container-small mx-auto">
        <b-button
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          :to="`/${$route.params.accountId}/account/balance#withdraw-requests`"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="saving || !isFormComplete || barVariant === 'danger'"
          @click.prevent="saveWithdraw(withdrawModel)"
        >
          {{ $tk('ClientPortal.Form.Actions.Save') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import notification from '@/mixins/toastification'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import ScrollContainer from '@/components/ScrollContainer.vue'
import AccountsService from '@/api/client/accounts.service'
import store from '@/store'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    GjIcon,
    ScrollContainer,
    vueDropzone,
  },
  mixins: [notification],
  data() {
    return {
      wrapper: {},
      errorMessages: {},
      status: false,
      loading: false,
      withdrawModel: {
        amount: 0,
        bankAccountNumber: 0,
        billNumber: '',
      },
      isAllProfitAdded: false,
      file: [],
      uploadStatusMessage: this.$tk('ClientPortal.Form.NoFileSelected'),
      saving: false,
      dropzoneOptions: {
        maxFiles: 1,
        uploadMultiple: false,
        acceptedFiles: '.pdf',
        url: 'url',
        thumbnailWidth: null,
        timeout: 0,
        thumbnailHeight: null,
        addRemoveLinks: true,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
      isError: false,
    }
  },
  computed: {
    isFormComplete() {
      const { amount, bankAccountNumber, billNumber } = this.withdrawModel

      return amount && bankAccountNumber && billNumber
    },
  },
  watch: {
    '$route.params.accountId': 'reloadWithdrawData',
  },
  async mounted() {
    this.loading = true
    try {
      const response = await AccountsService.getBalance('', '', this.$route.params.accountId)
      this.wrapper = response
    } catch (error) {
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      this.loading = false
      this.withdrawModel.bankAccountNumber = this.wrapper.bankAccountNumber
    }
  },
  methods: {
    async reloadWithdrawData() {
      this.loading = true
      try {
        const response = await AccountsService.getBalance('', this.$route.params.accountId)
        this.wrapper = response
      } catch (error) {
        this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
      } finally {
        this.withdrawModel = {
          amount: 0,
          bankAccountNumber: this.wrapper.bankAccountNumber,
          billNumber: '',
        }
        this.file = []
        this.loading = false
        // this.withdrawModel.bankAccountNumber = this.wrapper.bankAccountNumber
      }
    },
    addAllProfit() {
      if (this.isAllProfitAdded) {
        this.withdrawModel.amount = 0
      } else {
        this.withdrawModel.amount = this.wrapper.withdrawableAmount
      }
      this.isAllProfitAdded = !this.isAllProfitAdded
    },
    checkFileType(type) {
      return type === 'application/pdf'
    },
    setFile(file) {
      this.$refs.videoDropzone.removeFile(file)
      let uploadStatusMessage = ''
      if (this.checkFileType(file.type)) {
        this.file = file
        this.isError = false
        uploadStatusMessage = `${this.$tk('ClientPortal.Form.FileSelected')}: <b>${file.name}</b>`
      } else {
        this.file = []
        this.isError = true
        uploadStatusMessage = this.$tk('ClientPortal.Form.WrongFileFormatSelected')
      }
      document.getElementById('upload-status').innerHTML = uploadStatusMessage
    },
    async saveWithdraw(model) {
      this.saving = true
      const formData = new FormData()
      const { accountId } = this.$route.params
      formData.append('amount', model.amount)
      formData.append('bankAccountNumber', model.bankAccountNumber)
      formData.append('billNumber', model.billNumber)
      formData.append('file', this.file)
      if (model.message != null) formData.append('message', model.message)
      try {
        const response = await AccountsService.withdraw(formData, accountId)
        if (response.saved === true) {
          store.commit('app/TOGGLE_NEW_CREATE_STATE', true)
          this.$router.push(`/${accountId}/account/balance#withdraw-requests`)
          this.success(response.message)
        } else {
          this.errorMessages = response.errors
          this.error(response.message)
        }
      } catch (error) {
        this.error(error.message)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
